export enum FieldEnum {
  FIELD_TEXT = 'text',
  FIELD_DATE = 'date',
  FIELD_DATE_DAYLEFT = 'date_dayleft',
  FIELD_DATE_DAYLEFT_TEXT = 'date_dayleft_text',
  FIELD_DATETIME = 'datetime',
  FIELD_DATETIME_DAYLEFT = 'datetime_dayleft',
  FIELD_STATUS = 'status',
  FIELD_ACTION = 'action',
  FIELD_BUTTON = 'button',
  FIELD_BUTTON_TEXT = 'button_text',
  FIELD_CUSTOM = 'custom',
  FIELD_CHECKBOX = 'checkbox',
  FIELD_CUSTOM_LOCATION_NO = 'location_no',
}
